<template>
  <div class="list_cont">
    <em
      class="state"
      :class="getClass"
    >{{ progressOfStateName }}</em>
    <a
      v-if="finishedPayment"
      class="payment_link"
      @click.prevent="onClickPaymentInfo"
    >결제내역 확인</a>
  </div>
</template>

<script>
import { USER_STATUS_CODE } from '@/utils/constants';
import { openNewWindow } from '@/utils/common';

export default {
  name: 'StateDetailProgress',
  props: {
    progressOfState: {
      type: String,
      default: '',
    },
    progressOfStateName: {
      type: String,
      default: '',
    },
    orderKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      finishedPayment: false,
    };
  },
  computed: {
    getClass() {
      let classState = '';

      switch (this.progressOfState) {
        case USER_STATUS_CODE.CONSULTATION_SCHEDULED_VCALL:
        case USER_STATUS_CODE.CONSULTATION_SCHEDULED_ABC:
        case USER_STATUS_CODE.CONSULTATION_SCHEDULED_RECURRING:
          classState = "consulting_apply";
          break;
        case USER_STATUS_CODE.CONSULTATION_CANCELED:
          classState = "consulting_cancle";
          break;
        case USER_STATUS_CODE.RECURRING_PURCHASE_APPROVED:
          classState = "subdivide_confirm";
          break;
        case USER_STATUS_CODE.PRODUCT_UNAVAILABLE:
          classState = "consulting_cancle";
          break;
        case USER_STATUS_CODE.PAYMENT_FAILED:
          classState = "consulting_cancle";
          break;
        case USER_STATUS_CODE.CONSULTATION_INCOMPLETED:
          classState = "consulting_cancle";
          break;
        case USER_STATUS_CODE.PAYMENT_FINISHED:
          classState = "payment_confirm";
          this.showCheckPayment();
          break;
        case USER_STATUS_CODE.DIVISION_STARTED:
          classState = "subdivide_confirm";
          break;
        case USER_STATUS_CODE.DIVISION_FINISHED:
          classState = "subdivide_confirm";
          break;
        case USER_STATUS_CODE.PAYMENT_CANCELED:
          classState = "consulting_cancle";
          break;
      }
      return classState;
    },
  },
  methods: {
    showCheckPayment() {
      this.finishedPayment = true;
    },
    onClickPaymentInfo() {
      openNewWindow(`https://${process.env.SSO_HOST}/my-account/orders/${this.orderKey}`, 'store-finder');
    },
  },
};
</script>

<style>

</style>
